import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function Spandau() {
  return (
    <LocationPageTemplate
      page={{
        location: "Spandau",
        locationSlug: "spandau",
        keyword: "Haushaltsauflösung Spandau",
        metaTitle:
          "Haushaltsauflösung Spandau | Festpreis & Termin in 48h | MIROS",
        metaDesc:
          "Professionelle Haushaltsauflösung in Berlin Spandau. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung!",
        heroSub:
          "Ihre zuverlässige Haushaltsauflösung in Spandau – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909eeb899b8820e28a9a41.jpg",
        localIntro: (
          <>
            <p>
              Spandau ist fast wie eine eigene Stadt in Berlin. Der Bezirk im
              Westen bietet eine große Vielfalt an Wohnformen: Von der
              historischen Altstadt über die Großwohnsiedlungen im Falkenhagener
              Feld bis hin zu den weitläufigen Einfamilienhausgebieten in Gatow
              und Kladow. Jede dieser Gegenden bringt bei einer
              Haushaltsauflösung eigene Anforderungen mit sich.
            </p>
            <p>
              In der dicht bebauten Altstadt oder der Wilhelmstadt sind oft enge
              Treppenhäuser und die Einrichtung von Halteverbotszonen die größte
              Herausforderung. In den südlichen Ortsteilen wie Kladow geht es
              hingegen häufiger um die Räumung ganzer Grundstücke, inklusive
              Kellern, Garagen und Schuppen.
            </p>
            <p>
              Wir sind mit den örtlichen Gegebenheiten in Spandau bestens
              vertraut und bringen die nötige Erfahrung mit, um Ihre
              Entrümpelung effizient und stressfrei durchzuführen, egal in
              welchem Teil des Bezirks.
            </p>
          </>
        ),
        trustText:
          "Ob eine Wohnung in der Spandauer Altstadt oder ein Haus in Kladow – wir nehmen Ihnen die schwere Arbeit ab und stehen Ihnen diskret zur Seite.",
        trustQuote:
          "Das Team hat unsere Wohnung im Falkenhagener Feld super schnell und ordentlich geräumt. Absolut zu empfehlen!",
        challengesText: (
          <>
            <p>
              In den belebten Bereichen Spandaus kümmern wir uns zuverlässig um
              die Beantragung und Aufstellung von Halteverbotsschildern. So
              sichern wir kurze Wege für unser Team und einen zügigen
              Abtransport ohne Verkehrsbehinderungen.
            </p>
            <p>
              Bei der Räumung von Einfamilienhäusern im Süden Spandaus sorgen
              wir für ausreichend Transportfahrzeuge, um auch große Mengen an
              Sperrmüll aus Nebengebäuden schnell abzutransportieren. Die
              fachgerechte Trennung und Entsorgung auf den Berliner
              Recyclinghöfen ist dabei garantiert.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Pünktlich, freundlich und sehr schnell. Die Wohnung wurde komplett besenrein übergeben.",
            author: "Kunde aus der Altstadt Spandau",
          },
          {
            text: "Der Festpreis war sehr fair und wurde genau eingehalten. Keine versteckten Kosten.",
            author: "Kundin aus Haselhorst",
          },
          {
            text: "Die Räumung des Hauses meiner Eltern in Kladow wurde sehr respektvoll und professionell durchgeführt.",
            author: "Familie aus Kladow",
          },
        ],
        neighbors: [
          { name: "Charlottenburg", slug: "charlottenburg" },
          { name: "Reinickendorf", slug: "reinickendorf" },
          { name: "Berlin", slug: "berlin" },
        ],
        faqs: [
          {
            q: "Kümmern Sie sich um das Halteverbot in Spandau?",
            a: "Ja, wir übernehmen die komplette Beantragung beim Bezirksamt Spandau und stellen die Schilder auf.",
          },
          {
            q: "Räumen Sie auch Kellerabteile in Hochhäusern?",
            a: "Selbstverständlich. Wir entrümpeln auch einzelne Keller, Dachböden oder Garagen.",
          },
          {
            q: "Wie schnell können Sie mit der Räumung beginnen?",
            a: "Nach der kostenlosen Besichtigung können wir oft schon innerhalb weniger Tage mit der Arbeit starten.",
          },
          {
            q: "Werden verwertbare Möbel angerechnet?",
            a: "Ja, gut erhaltene Möbel oder Wertsachen können wir bei der Besichtigung fair bewerten und vom Preis abziehen.",
          },
        ],
      }}
    />
  );
}
